import React from "react";
import { Table, Button } from "react-bootstrap";

const TablaCitasClientes = ({
    citas,
    loading,
    pagina,
    totalPaginas,
    totalCitas,
    setPagina,
    onToggleConfirmada,
    onTogglePago,
    onEliminar
}) => {
    if (loading) return <p>Cargando citas de clientes...</p>;
    if (citas.length === 0) return <p className="text-muted">No hay citas de clientes registradas para este criterio.</p>;

    return (
        <div style={{ marginBottom: "50px" }}>
            <h4 style={{ color: "#007bff", marginBottom: "15px", fontWeight: "600" }}>Citas de Clientes</h4>
            
            <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "15px" }}>
                <Button size="sm" disabled={pagina === 1} onClick={() => setPagina(p => p - 1)}>Anterior</Button>
                <span>Página {pagina} de {totalPaginas} ({totalCitas} citas)</span>
                <Button size="sm" disabled={pagina >= totalPaginas} onClick={() => setPagina(p => p + 1)}>Siguiente</Button>
            </div>

            <Table hover responsive className="tabla-administracion shadow-sm">
                <thead className="table-primary">
                    <tr>
                        <th>Fecha / Hora</th>
                        <th>Cliente</th>
                        <th>Teléfono</th>
                        <th>Email</th>
                        <th>Masaje</th>
                        <th>Duración</th>
                        <th>Comentario</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {citas.map((cita) => (
                        <tr key={cita.id}>
                            <td>{new Date(cita.hora).toLocaleString()}</td>
                            <td>{cita.nombre} {cita.primer_apellido} {cita.segundo_apellido}</td>
                            <td>{cita.telefono}</td>
                            <td>{cita.email || "-"}</td>
                            <td>{cita.tipo_de_masaje}</td>
                            <td>{cita.duracion} min</td>
                            <td style={{ maxWidth: "180px", whiteSpace: "pre-wrap" }}>{cita.comentario_cliente || "-"}</td>
                            
                            <td style={{ width: "140px" }}>
                                <div style={{ display: "flex", flexDirection: "column", gap: "4px", width: "100%" }}>
                                    <Button 
                                        variant={cita.confirmada ? "success" : "outline-secondary"} 
                                        size="sm" 
                                        onClick={() => onToggleConfirmada(cita.id, cita.confirmada)} 
                                        style={{ fontSize: "0.75rem", padding: "3px 8px", fontWeight: "500", margin: "0px" }}
                                    >
                                        {cita.confirmada ? "Confirmada" : "Confirmar"}
                                    </Button>
                                    
                                    <Button 
                                        variant={cita.ha_pagado ? "success" : "outline-secondary"} 
                                        size="sm" 
                                        onClick={() => onTogglePago(cita.id, cita.ha_pagado)} 
                                        style={{ fontSize: "0.75rem", padding: "3px 8px", fontWeight: "500", margin: "0px" }}
                                    >
                                        {cita.ha_pagado ? "Pagada" : "Pdte. Pago"}
                                    </Button>
                                    
                                    <Button 
                                        variant="danger" 
                                        size="sm" 
                                        onClick={() => onEliminar(cita.id)}
                                        style={{ fontSize: "0.75rem", padding: "3px 8px", fontWeight: "500", margin: "0px" }}
                                    >
                                        Eliminar
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default TablaCitasClientes;